module.exports = __webpack_public_path__ + "assets/img/checkStatus_failed.1a0af72a.png";